"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const profile_1 = require("../../api/profile");
const ProfileComponent_1 = __importDefault(require("../../components/header/ProfileComponent"));
class ProfilePresenter {
    constructor(parentElement) {
        this.parentElement = parentElement;
        const profileDataPromise = (0, profile_1.getProfileData)();
        this.profileComponent = new ProfileComponent_1.default();
        this.render();
        profileDataPromise.then((profileData) => {
            this.profileComponent.profileData = profileData;
            this.render();
        });
    }
    render() {
        this.profileComponent.removeElement();
        this.parentElement.append(this.profileComponent.getElement());
    }
}
exports.default = ProfilePresenter;
